export { default } from './ModalPasswordExpired';
